module.exports = __webpack_public_path__ + "img/Profil_SESAM-TailWing_CS-Slimliner_ii_Standard.8601ac5c.jpg";